import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUserStore = defineStore('user', () => {
  const uid = ref(localStorage.getItem('uid') || null)
  const email = ref(localStorage.getItem('email') || null)
  const token = ref(localStorage.getItem('token') || null)
  const encryptionKey = ref(localStorage.getItem('encryptionKey') || null)
  const totpEnabled = ref(localStorage.getItem('totpEnabled') === 'true')
  const role = ref(localStorage.getItem('role') || 'member')
  const congregationId = ref(localStorage.getItem('congregationId') || null)

  const isLoggedIn = computed(() => !!token.value)
  const isSuperUser = computed(() => role.value === 'superuser')
  const isAdmin = computed(() => role.value === 'admin' || role.value === 'superuser')
  const hasCongregation = computed(() => !!congregationId.value)

  const setUser = (data) => {
    uid.value = data.uid
    email.value = data.email
    token.value = data.token
    encryptionKey.value = data.encryptionKey
    totpEnabled.value = !!data.totpEnabled
    role.value = data.role || 'member'
    congregationId.value = data.congregationId || null
    localStorage.setItem('uid', data.uid)
    localStorage.setItem('email', data.email)
    localStorage.setItem('token', data.token)
    localStorage.setItem('encryptionKey', data.encryptionKey)
    localStorage.setItem('totpEnabled', data.totpEnabled ? 'true' : 'false')
    localStorage.setItem('role', data.role || 'member')
    localStorage.setItem('congregationId', data.congregationId || '')
  }

  const updateAccount = (data) => {
    if (data.email !== undefined) {
      email.value = data.email
      localStorage.setItem('email', data.email)
    }
    if (data.token !== undefined) {
      token.value = data.token
      localStorage.setItem('token', data.token)
    }
  }

  const clearUser = () => {
    uid.value = null
    email.value = null
    token.value = null
    encryptionKey.value = null
    totpEnabled.value = false
    role.value = 'member'
    congregationId.value = null
    localStorage.removeItem('uid')
    localStorage.removeItem('email')
    localStorage.removeItem('token')
    localStorage.removeItem('encryptionKey')
    localStorage.removeItem('totpEnabled')
    localStorage.removeItem('role')
    localStorage.removeItem('congregationId')
  }

  return {
    uid, email, token, encryptionKey, totpEnabled, role, congregationId,
    isLoggedIn, isSuperUser, isAdmin, hasCongregation,
    setUser, updateAccount, clearUser,
  }
})
